import h from 'hyperscript';
import { t } from 'javascripts/utils/withTranslation';
import {
  makeFieldInvalid,
  clearFieldInvalid,
  registerHtml5Validation,
} from 'javascripts/utils/form-validation';

function getSearchQuery($form, $items) {
  if (!$items || !$form || !$form.action) {
    console.error('Solr submit - form or items not found');
    return '/';
  }

  let filterIndex = 0;

  const query = Array.from($items)
    .map(($item) => {
      const $input = $item;
      const name = $input.getAttribute('name');
      const { value } = $input;
      const isMultiselect =
        $input?.tagName?.toLowerCase() === 'select' && $input.multiple;

      if (!name || (!value && value !== '')) {
        return null;
      }

      if (name === 'tx_solr[q]') {
        const emptyValue = value === '' ? '*' : value;
        return `${name}=${emptyValue}`;
      }

      if (name !== 'tx_solr[filter]') {
        return `${name}=${value}`;
      }

      if (isMultiselect) {
        const multiString = [];
        Array.from($input.options).forEach(($o) => {
          const $option = $o;
          const adjustName = `tx_solr[filter][${filterIndex}]`;
          const adjustValue = `type:${$option.value}`;
          if ($option.selected) {
            multiString.push(`${adjustName}=${adjustValue}`);
            filterIndex += 1;
          }
          return null;
        });
        return multiString.join('&');
      }
      console.error('Solr submit - multiselect filter not found');
      return null;
    })
    .filter(Boolean)
    .join('&');

  return `${$form.action}?${query}`;
}

document.querySelectorAll('.js-solr-submit').forEach(($submit) => {
  const submit = (event) => {
    event.preventDefault();
    const $form = $submit.closest('form');
    const $items = $form.querySelectorAll('input, select');
    const submitQuery = getSearchQuery($form, $items);
    window.location.href = submitQuery;
  };

  $submit.addEventListener('click', submit);
});

// hook into html5 validation and collect all error messages on submit
document.querySelectorAll('form.form').forEach(($form) => {
  const $submit = $form.querySelector(
    'input[type=submit], button:not([type=button])',
  );
  registerHtml5Validation($form, $submit);
});
